import { uuid } from '@bp/shared/utilities/core';

type Uuid = string;
type Hex32 = string;

export function buildTraceparentHeader(id?: Hex32 | Uuid): string {
	let traceId = id?.replace(/-/gu, '');

	if (!traceId || !(/^[\da-f]{32}$/iu).test(traceId))
		traceId = uuid().replaceAll('-', '');

	const spanId = uuid()
		.replaceAll('-', '')
		.slice(0, 16);
	const traceFlags = '01'; // Sampled

	return `00-${ traceId }-${ spanId }-${ traceFlags }`;
}
